import React from 'react';

import { IMedia } from '../../../../../packages/Carousel/shared/types/media';
import { Thumbnail } from './Thumbnail';

import styles from './Thumbnails.css';
import { InlineText2 } from '@cian/ui-kit/typography';

interface IThumbnailsProps {
  media: Array<IMedia | null>;
  hasMore?: boolean;
}

export function Thumbnails({ media, hasMore }: IThumbnailsProps) {
  return (
    <div className={styles['wrapper']}>
      {media.map((thumbnail, i) => (
        <Thumbnail key={`thumbnail-${i}`} media={thumbnail}>
          {hasMore && i === media.length - 1 && (
            <div className={styles['overlay']}>
              <InlineText2 color="white_100">Ещё фото</InlineText2>
            </div>
          )}
        </Thumbnail>
      ))}
    </div>
  );
}
